module.exports = __webpack_public_path__ + "img/google-white.1b063c66.png";